import { render, staticRenderFns } from "./PosterShop.vue?vue&type=template&id=5831cdad&scoped=true&"
import script from "./PosterShop.vue?vue&type=script&lang=js&"
export * from "./PosterShop.vue?vue&type=script&lang=js&"
import style0 from "./PosterShop.vue?vue&type=style&index=0&id=5831cdad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831cdad",
  null
  
)

export default component.exports